import { render, staticRenderFns } from "./AboutNews.vue?vue&type=template&id=0c5bb712&scoped=true&"
import script from "./AboutNews.vue?vue&type=script&lang=js&"
export * from "./AboutNews.vue?vue&type=script&lang=js&"
import style0 from "./AboutNews.vue?vue&type=style&index=0&id=0c5bb712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bb712",
  null
  
)

export default component.exports